import React from "react";
import { observer } from "mobx-react";

import { EventOffer } from "@gp/offer";

import {
	EventName,
	EventMatchTime,
	EventTeamAggregatedScore,
} from "@features/offer/shared/event/details";
import { AdditionalOfferLinkWrapper } from "./AdditionalOfferLinkWrapper";
import { EventTeamsInfo } from "./EventTeamsInfo";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

export const PrematchEventInfo = observer(function PrematchEventInfo({
	event,
}: {
	event: EventOffer;
}) {
	const { t } = useTranslation();

	if (event.name) {
		return <EventName event={event} />;
	}

	const tooltipId = `aggregate-prematch-${event.id}`;

	let tooltipMessage = "";

	if (event.isLive) {
		tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.LIVE");
	} else {
		tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.PREMATCH");
	}

	return (
		<AdditionalOfferLinkWrapper>
			<EventTeamsInfo event={event}>
				<div className="event__middle">
					<EventMatchTime event={event} />
					<div
						className="tooltip-div"
						data-tooltip-id={tooltipId}
						data-tooltip-content={tooltipMessage}
						data-tooltip-position-strategy="fixed"
					>
						{event.result?.aggregateScore && (
							<div className="event__aggregate">
								<EventTeamAggregatedScore
									event={event}
									team="home"
								/>
								<span className="event__aggregate__middle">
									-
								</span>
								<EventTeamAggregatedScore
									event={event}
									team="away"
								/>
							</div>
						)}
					</div>

					<Tooltip
						id={tooltipId}
						className="at-tooltipTeams react-tooltip--primary"
						place="bottom"
						closeOnResize={true}
					/>
				</div>
			</EventTeamsInfo>
		</AdditionalOfferLinkWrapper>
	);
});
